export const filteredViews = {
  filtered_views: "Vistas filtradas",
  add_filtered_view: "Agregar vista filtrada",
  add_new_filtered_view: "Agregar nueva vista filtrada",
  create_filtered_view: "Crear vista filtrada",
  edit_filtered_view: "Editar vista filtrada",
  delete_filtered_view: "Eliminar vista filtrada",
  delete_filtered_view_confirmation: "¿Estás seguro de que quieres eliminar",
  delete_filtered_view_as: "como vista filtrada?",
  delete_filtered_view_warning: "Esta acción no se puede deshacer.",
  manage_filtered_views: "Gestionar vistas filtradas",
  manage_filtered_views_description:
    "Las vistas filtradas son vistas guardadas con filtros aplicados, columnas personalizadas y controles de filtro visibles.",
  default_filters: "Filtros predeterminados",
  no_saved_views: "Aún no hay vistas guardadas. Agrega una a continuación.",
  view_name: "Nombre de vista",
  view_name_placeholder: "ej. Facturas Vencidas",
  configure_view_description:
    "Configura los filtros aplicados, las columnas visibles y los controles de filtro de esta vista.",
  create_view: "Crear vista",
  save_changes: "Guardar cambios",
  skip: "Omitir",
  enter_view_name: "Ingresa un nombre de vista",
  visit_all_tabs: "Visita todas las pestañas primero",
  tab_apply_filters: "Aplicar filtros",
  tab_select_columns: "Columnas",
  tab_select_document_filters: "Filtros de documento",
  tab_user_access: "Acceso de usuarios",
  user_access_title: "Seleccionar usuarios con acceso a esta vista",
  user_access_description:
    "Elige a qué usuarios se bloquea esta vista por defecto.",
  no_users_available: "No hay usuarios disponibles",
  select_columns_description: "¿Qué columnas quieres ver en la tabla de esta vista?",
  search_columns: "Buscar columnas",
  add_new_column: "Agregar nueva columna",
  no_columns_match: "Ninguna columna coincide con tu búsqueda",
  select_document_filters_title: "Seleccionar filtros de campo de documento para ver directamente",
  select_document_filters_description:
    "Qué filtros de campo de documento quieres usar directamente en esta vista.",
  field_name: "Nombre del campo",
  add_another_document_field: "Agregar otro campo de documento",
  add_new_column_title: "Agregar nueva columna",
  search_fields: "Buscar campos",
  all_fields_added: "Todos los campos ya fueron agregados",
  no_fields_match: "Ningún campo coincide con tu búsqueda",
  cols: "cols",
  col: "col",
  applied_filters: "filtros aplicados",
  applied_filter: "filtro aplicado",
  visible_filters: "filtros visibles",
  visible_filter: "filtro visible",
  view_created_successfully: "Vista creada con éxito",
  view_updated_successfully: "Vista actualizada con éxito",
  view_deleted_successfully: "Vista eliminada con éxito",
  view_saved: "Vista guardada",
  save_in_filtered_view: "Guardar en vista filtrada",
  custom_filters: "Filtros personalizados",
  enable_document_custom_view_permission: "Activa el permiso de Vista Personalizada de Documentos para usar vistas filtradas.",
  back_to_manage: "Volver a gestionar",
  user_already_locked_to_another_view: "Uno o más usuarios seleccionados ya están bloqueados en otra vista.",
};
